import { cx } from '../utils.ts';
import './display.css';

/*
 * The Tomo mark: a jeweled tome. A gold cover with a spine and a gem, over a cream page block
 * and a darker back cover, so it reads as one thick book from 16px up. The outline keeps it
 * crisp on the light theme too. `apps/web/public/favicon.svg` is the same drawing.
 */
const OUTLINE = '#6B3F05';

export function LogoMark({ size = 24, className, title = 'Tomo' }: { size?: number; className?: string; title?: string }) {
  return (
    <svg className={cx('g-logo-mark', className)} width={size} height={size} viewBox="0 0 32 32" role="img" aria-label={title}>
      <rect x="5.8" y="3.8" width="23" height="27" rx="2" fill="#B97418" stroke={OUTLINE} strokeOpacity="0.6" strokeWidth="0.8" />
      <rect x="5.8" y="3.4" width="22" height="26.2" rx="1.4" fill="#FFF1CC" />
      <path d="M26.4 5.6V27.4M27.2 6V27M8.5 29H24.8" stroke="#DDB56A" strokeWidth="0.55" strokeLinecap="round" />
      <rect x="3.2" y="1.8" width="22.3" height="26.7" rx="2" fill="#F2B84A" />
      <path d="M5.2 1.8H9V28.5H5.2A2 2 0 0 1 3.2 26.5V3.8A2 2 0 0 1 5.2 1.8Z" fill="#C98320" />
      <path d="M3.6 6.9H9M3.6 23.4H9" stroke="#F7CF72" strokeWidth="1.1" />
      <rect x="11" y="4.6" width="12" height="21.2" rx="1.2" fill="none" stroke="#B97418" strokeOpacity="0.8" strokeWidth="0.8" />
      <polygon points="17,8.4 22.2,14.4 17,22 11.8,14.4" fill={OUTLINE} fillOpacity="0.85" />
      <polygon points="12.9,14.4 17,9.7 17,14.4" fill="#FFF7DF" />
      <polygon points="17,9.7 21.1,14.4 17,14.4" fill="#FFE29A" />
      <polygon points="12.9,14.4 17,14.4 17,20.6" fill="#F3B545" />
      <polygon points="17,14.4 21.1,14.4 17,20.6" fill="#D08A20" />
      <rect x="3.2" y="1.8" width="22.3" height="26.7" rx="2" fill="none" stroke={OUTLINE} strokeOpacity="0.6" strokeWidth="0.9" />
      <path d="M10.4 3H16.2" stroke="#FFFFFF" strokeOpacity="0.55" strokeWidth="0.8" strokeLinecap="round" />
    </svg>
  );
}

export function Logo({ size = 24, wordmark = true, className }: { size?: number; wordmark?: boolean; className?: string }) {
  return (
    <span className={cx('g-logo', className)} style={{ ['--logo-size' as string]: `${size}px` }}>
      <LogoMark size={size} />
      {wordmark && <span className="g-logo__word">Tomo</span>}
    </span>
  );
}
